export default __webpack_public_path__ + "static/media/weekly-img.a5bb6445.svg";